<template>
  <v-layout wrap>
    <!-- Field -->
    <v-flex sm12 md4>
      <v-autocomplete
        dense
        :items="fields"
        return-object
        :placeholder="$t('MASSEDIT_PROMPT_CHOOSE_FIELD')"
        v-model="meneItem.field"
        clearable
        menu-props="auto"
        @change="onChangeField()"
      >
        <template v-slot:selection="data">
          {{ data.item ? data.item.label : '' }}
        </template>
        <template v-slot:item="data">
          <!-- Divider and Header-->
          <template v-if="typeof data.item === 'object'">
            <v-list-item-content v-text="data.item.label"/>
          </template>
          <!-- Normal item -->
          <template v-else>
            {{ data.item }}
          </template>
        </template>
      </v-autocomplete>
      <span v-if="debug">{{ meneItem.field }}</span>
    </v-flex>
    <!-- Condition -->
    <v-flex sm12 md2>
      <v-select
        dense
        :items="myCommands"
        return-object
        :placeholder="$t('MASSEDIT_PROMPT_CHOOSE_ACTION')"
        :disabled="!meneItem.field"
        v-model="meneItem.command"
        clearable
        @change="onChangeCommand()"
      >
        <template v-slot:selection="data">
          {{ data.item ? data.item.label : '' }}
        </template>
        <template v-slot:item="data">
          <!-- Divider and Header-->
          <template v-if="typeof data.item === 'object'">
            <v-list-item-content v-text="data.item.label"/>
          </template>
          <!-- Normal item -->
          <template v-else>
            {{ data.item }}
          </template>
        </template>
      </v-select>
      <span v-if="debug">{{ meneItem.command }}</span>
    </v-flex>
    <!-- Value -->
    <v-flex sm10 md5>
      <template v-if="_valueTextField">
        <v-text-field
          dense
          placeholder=""
          :disabled="!meneItem.command"
          v-model="meneItem.value"
        >
        </v-text-field>
      </template>
      <v-autocomplete
        v-if="_valueSelect"
        dense
        :multiple="select_multiple"
        :items="select"
        :placeholder="$t('MASSEDIT_PROMPT_CHOOSE_VALUE')"
        :disabled="!meneItem.command"
        v-model="meneItem.value"
        clearable
        menu-props="auto"
      >
      </v-autocomplete>

      <v-autocomplete
        v-if="_valueCatlist"
        dense
        :items="catlist"
        :placeholder="$t('MASSEDIT_PROMPT_CHOOSE_VALUE')"
        :multiple-="select_multiple"
        :disabled="!meneItem.command"
        v-model="meneItem.value"
        clearable
        menu-props="auto"
      >
      </v-autocomplete>
      <span v-if="debug">{{ meneItem.value }}</span>
    </v-flex>
    <v-flex sm2 md1 class="row-actions pa-0">
      <v-btn small icon @click="onRemove()"><v-icon>mdi-minus-circle-outline</v-icon></v-btn>
      <v-btn v-if="hasAdd" small icon @click="onAdd()"><v-icon>mdi-plus-circle-outline</v-icon></v-btn>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'
import { selectValues } from '../config/SelectValues'

export default {
  name: 'SearchViewBlockItem',
  props: ['idx', 'meItem', 'hasAdd', 'debug', 'fields', 'commands'],
  data() {
    return {
      def_commands: require('../config/commands.json'),
      // def_select_values: require('../config/select_values.json') // computed
    }
  },
  computed: {
    ...mapGetters(['data', 'countries']),
    meneItem() {
      return this.meItem
    },
    myCommands() {
      let commands = []
      const datatype = this.meneItem && this.meneItem.field ? this.meneItem.field.datatype : 'default'
      commands = this.commands[datatype] && Array.isArray(this.commands[datatype])
        ? this.commands[datatype].filter(a => a.id.indexOf('_') !== 0 && (a.id !== 'del' || this.meneItem && this.meneItem.field.multiple === '1')) : []
      commands = commands.map(a => ({ ...a, label: this.$t(a.text) }))
      return commands
    },
    def_select_values() { return selectValues.get(this) },
    // fields() {
    //   let fields = [], _fields

    //   _fields = this.data.fields.filter(a => this.def_commands[a.datatype] && Array.isArray(this.def_commands[a.datatype]) && this.def_commands[a.datatype].filter(a => a.id.indexOf('_') !== 0).length)
    //   if (_fields.length) {
    //   //   fields.push({ header: '' })
    //     fields.push(..._fields
    //       .map(a => ({ ...a, value: `i${a.value}`, label: this.$t(a.text) }))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
    //   }

    //   _fields = this.data.categories.filter(a => this.def_commands[a.datatype] && Array.isArray(this.def_commands[a.datatype]) && this.def_commands[a.datatype].filter(a => a.id.indexOf('_') !== 0).length)
    //   if (_fields.length) {
    //     fields.push({ header: this.$t('CONTACT_CATEGORIES') })
    //     fields.push(..._fields
    //       .map(a => ({ ...a, value: `c${a.value}`}))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
    //   }

    //   _fields = this.data.custom_fields.filter(a => this.def_commands[a.datatype] && Array.isArray(this.def_commands[a.datatype]) && this.def_commands[a.datatype].filter(a => a.id.indexOf('_') !== 0).length)
    //   if (_fields.length) {
    //     fields.push({ header: this.$t('CONTACT_FREE_FIELDS') })
    //     fields.push(..._fields
    //       .map(a => ({ ...a, value: `f${a.value}`}))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
    //   }

    //   _fields = this.data.additional_fields.filter(a => this.def_commands[a.datatype] && Array.isArray(this.def_commands[a.datatype]) && this.def_commands[a.datatype].filter(a => a.id.indexOf('_') !== 0).length)
    //   if (_fields.length) {
    //     fields.push({ header: this.$t('EXTSEARCH_NOTES_SEPARATOR') })
    //     fields.push(..._fields
    //       .map(a => ({ ...a, value: `a${a.value}`}))) // alter value so the v-select/v-autocomplete component can show all items (prevent duplicate IDs)
    //   }

    //   return fields
    // },
    // commands() {
    //   let commands = []
    //   const datatype = this.meneItem.field ? this.meneItem.field.datatype : 'default'
    //   commands = this.def_commands[datatype] && Array.isArray(this.def_commands[datatype])
    //     ? this.def_commands[datatype].filter(a => a.id.indexOf('_') !== 0 && (a.id !== 'del' || this.meneItem.field.multiple === '1')) : []
    //   commands = commands.map(a => ({ ...a, label: this.$t(a.text) }))
    //   return commands
    // },
    select() {
      if (this.meneItem.field.datatype === 'country') {
        return this.countries
      }
      const field_id = this.meneItem.field ? this.meneItem.field.id : null
      return field_id && this.def_select_values[field_id] && Array.isArray(this.def_select_values[field_id]) ? this.def_select_values[field_id].filter(a => a.id.indexOf('_') !== 0) : []
    },
    select_multiple() {
      return this.meneItem.field.multiple === '1'
    },
    catlist() {
      const field_id = this.meneItem.field ? this.meneItem.field.id : null
      const category = field_id ? this.data.categories.find(a => a.id === field_id) : null
      return category && category.children && Array.isArray(category.children) ? category.children.map(a => Object.assign(a, {id: a.id, value: a.id, label: a.name, text: a.name})) : []
    },

    _valueTextField() {
      return this.meneItem.field
        && (
          this.meneItem.field.datatype === 'default'
          || this.meneItem.field.datatype === 'relation'
          || this.meneItem.field.datatype === 'free'
          || this.meneItem.field.datatype === 'notice'
        )
        && (
          !this.meneItem.command
          || !['clear'].includes(this.meneItem.command.id)
        )
    },
    _valueSelect() {
      return this.meneItem.field
        && ( this.meneItem.field.datatype === 'select'
          || this.meneItem.field.datatype === 'country'
        )
        && (
          !this.meneItem.command
          || !['clear'].includes(this.meneItem.command.id)
        )
    },
    _valueCatlist() {
      return this.meneItem.field
        && this.meneItem.field.datatype === 'catlist'
        && (
          !this.meneItem.command
          || !['clear'].includes(this.meneItem.command.id)
        )
    },
  },
  watch: {
    // 'meneItem.field'(val) {
    //   if (!val) {
    //     this.meneItem.command = null
    //   } else {
    //     // this.meneItem.command = this.commands[0] || null
    //     this.meneItem.command = null
    //   }
    // },
    // 'meneItem.command'() {
    //   if (this.meneItem.field && this.meneItem.field.datatype === 'select') {
    //     // this.meneItem.value = this.select[0].value
    //     this.meneItem.value = ''
    //   } else {
    //     this.meneItem.value = ''
    //   }
    //   // this.meneItem.date.year = null
    // },
  },

  methods: {
    onAdd() {
      this.$emit('add')
    },
    onRemove() {
      this.$emit('remove')
    },
    onChangeField(){
      this.meneItem.command = null
    },
    onChangeCommand(){
      this.meneItem.value = ''
    }
  }
}
</script>

<style scoped lang="scss">
.and-divider {
  width: 5cm;
  // margin: 0px auto;
  // border-radius: 8px;
}
.v-text-field {
  padding-top: 0;
  margin-top: 0;
}
.v-input {
  font-size: 0.8em;
}
.v-select { // TODO: needs improvement
  .v-select__selections {
    word-wrap: none;
    text-overflow: ellipsis;
  }
}
.v-select-list {
  .v-list__tile {
    font-size: 0.8em;
    height: 26px !important;
    padding: 0 8px;
  }
}
.or {
  min-width: 0;
}
.row-actions .v-btn {
  margin-left: 0;
  margin-right: 0;
}
</style>
